/** @format */

import './laminate_material_select_descriptions.scss';
import React from 'react';

export const OptionDescription = ({option, className = ''}) => (
    <div className={`${className} option-description-27kc p-4 bg-structure-lightest`}>
        <h4
            className="font-heading-sm m-0 p-0 d-flex align-items-center justify-content-start gap-1"
            style={{lineHeight: 1}}>
            <span>{option.label}</span>
            {option?.labelExtraDetails && (
                <span className="label-extra-description-27kc bg-accent-primary font-body-bold-sm rounded ml-2 flex-shrink-0 ">
                    {option.labelExtraDetails}
                </span>
            )}
        </h4>
        <p className="m-0 p-0">{option.info}</p>
        <a
            className="color-action-primary"
            href={option.url}
            target="_blank"
            style={{
                whiteSpace: 'nowrap'
            }}>
            <b>View more</b>
        </a>
    </div>
);
